<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height pa-0"
        fluid
        :style="`background-image: url('${backgroundImage}'); background-position: center center; background-size: cover;`"
      >
        <v-col offset-sm="1" sm="10">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="6">
              <v-card class="elevation-12">
                <v-col class="d-flex justify-center pt-12">
                 <v-avatar size="400" max-height="60px" tile>
                    <v-img :src="logoImage" height="100%" contain />
                  </v-avatar>
                </v-col>

                <v-card-title class="d-flex justify-center pt-0">
                  <h5 class="text--disabled font-weight-light">
                   Recuperação de Senha
                  </h5>
                </v-card-title>
                <v-card-text>
                  <core-form
                    v-show="!msgRecuperacaoSuccess"
                    :submit="recuperarSenha"
                  >
                    <v-col cols="12" class="py-0">

                      <input-email required v-if="loginField === 'email'" label="E-mail" v-model="model[loginField]" autofocus placeholder=" " />
                      <input-documento required v-if="loginField === 'documento'" label="CPF/CNPJ" v-model="model[loginField]" autofocus placeholder=" " />
                      <input-text required v-if="loginField === 'username'" label="Usuário" v-model="model[loginField]" autofocus placeholder=" " />

                    </v-col>
                    <v-col cols="12">
                      <v-btn
                        type="submit"
                        block
                        color="primary"
                        >Enviar Recuperação de Senha</v-btn
                      >
                    </v-col>
                    <v-col cols="5">
                      <router-link
                        to="/"
                        class="font-weight-medium caption text-decoration-none"
                        >Voltar ao login</router-link
                      >
                    </v-col>
                  </core-form>

                  <v-col cols="12" class="pt-0" style="min-height: 80px">
                    <template v-if="msgRecuperacaoError">
                    <v-alert type="error" class="mt-3 mb-0" text>
                      {{ msgRecuperacaoError }}
                    </v-alert>
                    </template>

                    <template v-if="msgRecuperacaoSuccess">
                    <v-alert type="success"  class="mt-3 mb-0" text>
                      {{ msgRecuperacaoSuccess }}
                    </v-alert>
                    <br />
                    <router-link
                      to="/"
                      class="font-weight-medium caption text-decoration-none"
                      >Voltar ao login</router-link
                    >
                    </template>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  metaInfo: {
    title: 'Recuperação de Senha'
  },
  props: {
    logoImage: { type: String, default: require('shared/images/svg/logo-black.svg') },
    backgroundImage: {
      type: String,
      default: require('shared/images/svg/background.svg')
    },
    loginField: { type: String, default: 'email' },
  },
  data: () => ({
    model: { Login: '', PrimeiroAcesso: false },
    msgRecuperacaoError: '',
    msgRecuperacaoSuccess: ''
  }),
  methods: {
    recuperarSenha () {
      const th = this
      th.clearMsgs()
      th.$api.Autenticacao.SolicitarLinkSenha(th.model).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          var email = response.email || th.model.email
          th.$set(th, 'msgRecuperacaoSuccess', `Recuperação de senha enviado para: ${email}`)
        } else {
          th.$set(th, 'msgRecuperacaoError', response.mensagem)
        }
      })
    },
    clearMsgs () {
      this.msgRecuperacaoError = ''
      this.msgRecuperacaoSuccess = ''
    }
  }
}
</script>
